/** English is the source of every key; other languages fall back to it key by key. */
export const en = {
  'nav.dashboard': 'Dashboard',
  'nav.stake': 'Stake',
  'nav.bond': 'Bond',
  'nav.swap': 'Swap',
  'nav.liquidity': 'Liquidity',
  'nav.referral': 'Referral',
  'nav.docs': 'Docs',
  'nav.admin': 'Admin',
  'nav.more': 'More',
  'wallet.connect': 'Connect wallet',
  'wallet.choose': 'Choose a wallet',
  'wallet.disconnect': 'Disconnect',
  'wallet.copy': 'Copy address',
  'wallet.copied': 'Copied',
  'wallet.none': 'No wallet found. Install a wallet extension such as MetaMask, Trust Wallet, Binance Wallet or OKX Wallet, or open this page in your wallet app.',
  'wallet.walletconnect': 'WalletConnect (mobile wallets, Binance Wallet, Safe and 300+ more)',
  'wallet.openIn': 'Open in {wallet}',
  'wallet.mobileHint': 'On a phone, open this page inside your wallet app, or connect any wallet with WalletConnect.',
  'wallet.safety': 'Connecting only shares your address. Every transaction is shown in your wallet before you sign.',
  'network.wrong': 'Wrong network',
  'network.switch': 'Switch to {chain}',
  'common.close': 'Close',
  'common.max': 'MAX',
  'common.balance': 'Balance',
  'common.approve': 'Approve {token}',
  'common.confirmInWallet': 'Confirm in your wallet…',
  'common.pending': 'Waiting for confirmation…',
  'common.done': 'Done',
  'common.viewTx': 'View transaction',
  'common.connectFirst': 'Connect your wallet to continue',
  'common.enterAmount': 'Enter an amount',
  'common.insufficient': 'Insufficient {token} balance',
  'common.loading': 'Loading…',
  'common.notAdvice': 'Rates, ROI and APY are calculated from current parameters and change over time. They are not promises of future returns.',
  'page.dashboard.title': 'Dashboard',
  'page.stake.title': 'Stake',
  'page.bond.title': 'Bond',
  'page.swap.title': 'Swap',
  'page.liquidity.title': 'Liquidity',
  'page.referral.title': 'Referral',
  'page.docs.title': 'Docs',
  'page.admin.title': 'Admin',
  'dash.eyebrow': 'Protocol',
  'dash.title': 'Overview',
  'dash.price': 'SYN price',
  'dash.priceSub': '30-min TWAP · spot {spot}',
  'dash.marketCap': 'Market cap',
  'dash.treasury': 'Treasury (risk-free)',
  'dash.treasurySub': 'USDT + BNB + LP held by the treasury',
  'dash.backing': 'Backing per SYN',
  'dash.staked': 'Staked',
  'dash.stakedSub': 'of total supply',
  'dash.apySub': '{rate} per 12 h epoch',
  'dash.index': 'sSYN index',
  'dash.nextRebase': 'Next rebase',
  'dash.runway': 'Runway',
  'dash.runwayDays': '{n} days',
  'dash.runwaySub': 'treasury ÷ daily reward value',
  'dash.mcapVsBacking': 'Market cap vs treasury backing',
  'dash.premium': 'The market values SYN at {x}× its treasury backing.',
  'dash.yourPosition': 'Your position',
  'dash.wallet': 'In wallet',
  'dash.bonds': 'Bonds',
  'dash.bondCount': '{n} position(s)',
  'dash.referral': 'Referral claimable',
  'dash.how': 'How it works',
  'dash.how1': 'Bond BNB, USDT or SYN-USDT LP to buy SYN below market. It unlocks in full after 7 days.',
  'dash.how2': 'Stake SYN in one of six plans, from no lock to permanent; every plan compounds every 12 hours.',
  'dash.how3': 'Rewards are newly minted within per-epoch caps. Bond payments build the treasury, which buys SYN back after sharp drops.',
  'dash.how4': 'Invite friends: earn 5% of your direct referrals’ staking rewards plus a rank-based share of your weaker leg, up to 300% of your stake.',
  'stake.eyebrow': 'Staking',
  'stake.title': 'Stake SYN',
  'stake.amount': 'Amount to stake',
  'stake.fee': 'Stake fee ({pct})',
  'stake.youGet': 'You receive',
  'stake.unlocks': 'Unlocks',
  'stake.exitFee': 'Unstake fee',
  'stake.exitFeeNote': '{pct} of everything you take out of staking',
  'stake.principal': 'Counts as principal',
  'stake.cta': 'Stake · {plan}',
  'stake.positions': 'Your stakes',
  'stake.noLots': 'No stakes yet.',
  'stake.lockedUntil': 'Locked',
  'stake.withdrawn': 'Withdrawn',
  'stake.withdraw': 'Withdraw',
  'stake.youReceiveNet': 'You receive {amount} SYN after the {pct} fee',
  'stake.projection': 'Projection',
  'stake.projectionNote': 'If today’s rate held for the whole period. Rates change every epoch, and the reward budget can lower them.',
  'stake.after': 'After {period}',
  'stake.d30': '30 days',
  'stake.d90': '90 days',
  'stake.d365': '1 year',
  'stake.nothingPending': 'No pending rewards yet',
  'common.approved': '{token} approved',
  'bond.eyebrow': 'Bonds',
  'bond.title': 'Buy SYN below market',
  'bond.price': 'SYN price',
  'bond.treasury': 'Treasury',
  'bond.open': 'Open markets',
  'bond.openOf': '{n} of {m}',
  'bond.outstanding': 'Outstanding payouts',
  'bond.outstandingSub': 'SYN vesting across all bonds',
  'bond.markets': 'Bond markets',
  'bond.asset': 'Asset',
  'bond.bondPrice': 'Bond price',
  'bond.roi': 'ROI',
  'bond.discount': 'Discount',
  'bond.capacity': 'Capacity left',
  'bond.vesting': 'Vesting',
  'bond.days7': '7 days (cliff)',
  'bond.closed': 'Closed',
  'bond.select': 'Bond',
  'bond.form': 'Bond {asset}',
  'bond.pay': 'You pay',
  'bond.value': 'Value',
  'bond.receive': 'You receive',
  'bond.unlock': 'Unlocks in full',
  'bond.feeNote': '15% of the payment goes to the fee wallet, 85% to the treasury. Both are already in the price.',
  'bond.slippage': 'Max price movement',
  'bond.minReceive': 'Minimum you receive',
  'bond.cta': 'Bond',
  'bond.overMax': 'Max {amount} per bond',
  'bond.overCap': 'Only {amount} left this period',
  'bond.soldOut': 'Sold out for this period',
  'bond.maxPer': 'Max per bond',
  'bond.leftNow': 'Left this period',
  'bond.limitVal': '{payout} SYN ≈ {amount}',
  'bond.paused': 'Bonds paused for now',
  'bond.pausedTitle': 'Bonds are paused for now. ',
  'bond.pausedWhy': 'The pool price ({spot}) is {dev} away from its 30-minute average ({twap}). To protect against price manipulation, bonds only open while the two are within {max}. They reopen by themselves as the average catches up, usually within 30 minutes, or sooner if the price moves back. Staking, swaps and claims keep working.',
  'bond.roiExplain': 'ROI is what you gain at today’s market price once the bond unlocks. It falls as a market sells more and recovers over time.',
  'bond.positions': 'Your bonds',
  'bond.chainId': 'Bond ID {id} on the contract',
  'bond.none': 'No bonds yet.',
  'bond.payout': 'Payout',
  'bond.market': 'Market',
  'bond.status': 'Status',
  'bond.vestingStatus': 'Vesting',
  'bond.claimable': 'Claimable',
  'bond.claimed': 'Claimed',
  'bond.claimAll': 'Claim {n}',
  'bond.claimStake': 'Claim & stake {n}',
  'bond.into': 'Stake into',
  'bond.claimableTotal': '{amount} SYN claimable',
  'swap.eyebrow': 'PancakeSwap V2',
  'swap.title': 'Swap',
  'swap.pay': 'You pay',
  'swap.receive': 'You receive (estimated)',
  'swap.flip': 'Switch direction',
  'swap.rate': 'Rate',
  'swap.minReceived': 'Minimum received',
  'swap.impact': 'Price impact',
  'swap.route': 'Route',
  'swap.fee': 'Pool fee',
  'swap.slippage': 'Slippage tolerance',
  'swap.cta': 'Swap',
  'swap.highImpact': 'High price impact: you get a rate {pct} worse than the current price. Consider a smaller amount.',
  'swap.noRoute': 'No pool for this pair',
  'swap.noTax': 'SYN has no transfer tax: only the pool fee and price impact apply.',
  'swap.pool': 'SYN-USDT pool',
  'swap.reserves': 'Reserves',
  'swap.tvl': 'Pool value',
  'liq.eyebrow': 'PancakeSwap V2',
  'liq.title': 'SYN-USDT liquidity',
  'liq.add': 'Add',
  'liq.remove': 'Remove',
  'liq.first': 'Deposit both tokens at the pool’s current ratio. You receive LP tokens for your share; every swap pays a fee into the pool.',
  'liq.share': 'Your share after',
  'liq.slippage': 'Max slippage',
  'liq.noLp': 'You have no LP tokens in this pool yet. Add liquidity first.',
  'liq.lpOut': 'LP tokens you receive',
  'liq.ctaAdd': 'Add liquidity',
  'liq.removeAmount': 'LP tokens to remove',
  'liq.youGet': 'You receive',
  'liq.ctaRemove': 'Remove liquidity',
  'liq.position': 'Your position',
  'liq.lpBalance': 'LP tokens',
  'liq.poolShare': 'Pool share',
  'liq.underlying': 'Underlying',
  'liq.bondIt': 'LP tokens can be bonded in the SYN-USDT LP market for a discount.',
  'liq.goBond': 'Go to bonds',
  'liq.risk': 'Providing liquidity carries impermanent-loss, slippage and smart-contract risk.',
  'ref.eyebrow': 'Binary tree',
  'ref.title': 'Referral',
  'ref.rank': 'Rank',
  'ref.left': 'Left leg (active)',
  'ref.right': 'Right leg (active)',
  'ref.matched': 'Matched (weaker leg)',
  'ref.claimable': 'Claimable',
  'ref.direct': 'Direct referrals',
  'ref.directSub': '{bps} of their staking rewards',
  'ref.cap': 'Referral cap',
  'ref.capUsed': '{used} of {cap} used',
  'ref.capNote': 'Referral rewards plus principal you withdraw count toward 300% of your peak active stake. Stake more to raise it.',
  'ref.inviteTitle': 'Your invite link',
  'ref.inviteAbout': 'New members join the side you choose and take their place in your team with their first stake, at that side’s outermost free spot. You earn the direct bonus on everyone you invite, and binary rewards on your weaker leg.',
  'ref.placeLeft': 'Left',
  'ref.placeRight': 'Right',
  'ref.copy': 'Copy link',
  'ref.copied': 'Copied',
  'ref.yourCode': 'Your invite code',
  'ref.codeNote': 'Linked to your wallet {address}. Codes exist only for members, so a made-up code leads nowhere.',
  'ref.copyCode': 'Copy code',
  'ref.sponsorHint': 'e.g. K7Q2M9XA, or 0x…',
  'ref.lookingUp': 'Looking up the invite code…',
  'ref.codeUnknown': 'No member has this invite code',
  'ref.lookupFailed': 'Could not look up the code right now. Paste the referrer’s address instead',
  'ref.needStake': 'Stake SYN (or bind to a referrer) to get your invite link.',
  'ref.bindTitle': 'Join under a referrer',
  'ref.bindAbout': 'Joining is permanent and must happen before your first stake; otherwise you are placed under the project. You take your place in the tree with your first stake.',
  'ref.sponsor': 'Invite code or referrer address',
  'ref.side': 'Side',
  'ref.sideHint': 'Which of your two teams they join. Binary rewards are paid on the smaller team, and ranks need both teams, so grow both sides.',
  'ref.sideHintJoin': 'Which of your referrer’s two teams you join. The link already picked one; you can change it before you bind.',
  'join.invited': 'You were invited by {sponsor} (code {code}, {side} team). Join their team now; you take your place in the tree with your first stake. A first stake made without joining places you under the project’s default sponsor, permanently.',
  'join.cta': 'Join referrer',
  'join.left': 'left',
  'join.right': 'right',
  'join.none': 'You have not joined a referral team yet: this stake places you under the project’s default sponsor, permanently. Invited by someone? Open their invite link first.',
  'ref.bindCta': 'Bind referrer',
  'ref.badAddress': 'Enter an invite code or a wallet address',
  'ref.sponsorUnknown': 'This referrer has not joined yet',
  'ref.sponsorOk': 'Referrer found: {address}',
  'ref.bound': 'Your referrer',
  'ref.placedUnder': 'placed under {parent} on the {side}',
  'ref.notPlacedYet': 'your place in the tree comes with your first stake',
  'ref.teamTitle': 'Your team',
  'ref.teamPlaced': 'In your team',
  'ref.teamPending': 'Joined, not staked yet',
  'ref.teamEmpty': 'Nobody has joined through your link yet.',
  'ref.teamPendingNote': 'They take their place in your team with their first stake.',
  'ref.teamMember': 'Member',
  'ref.teamSide': 'Side',
  'ref.teamStake': 'Active stake',
  'ref.ladder': 'Ranks',
  'ref.ladderNote': 'A rank needs both legs’ active stakes, held at the same time, with at least {pct} of the total on each side. A rank once reached is kept for life.',
  'ref.member': 'Member',
  'ref.bronze': 'Bronze',
  'ref.silver': 'Silver',
  'ref.gold': 'Gold',
  'ref.diamond': 'Diamond',
  'ref.crown': 'Crown',
  'ref.rate': 'Binary rate',
  'ref.needs': 'Needs',
  'ref.total': 'Total',
  'ref.weaker': 'Weaker side',
  'ref.reached': 'Reached',
  'ref.tree': 'Your tree',
  'ref.treeAbout': 'Tap a member to see their side of the tree.',
  'ref.you': 'You',
  'ref.legendLeft': 'Left team',
  'ref.legendRight': 'Right team',
  'ref.openSlot': 'Open slot',
  'ref.legendFlow': 'Active stake counts up to the top',
  'ref.back': 'Back to me',
  'ref.own': 'Own stake',
  'ref.claimTitle': 'Claim referral rewards',
  'ref.claimAbout': 'Paid in newly minted SYN at the 30-minute average price. Requires an active stake.',
  'ref.approx': '≈ {amount} SYN',
  'ref.claimCta': 'Claim',
  'ref.notEligible': 'Stake SYN to claim referral rewards',
  'docs.eyebrow': 'Guide',
  'docs.title': 'How Syntra works',
  'docs.bondH': 'Bonds',
  'docs.bondP': 'Pay with BNB, USDT or SYN-USDT LP and receive SYN worth more than you paid at today’s price (the ROI). The whole payout unlocks exactly 7 days after purchase; each purchase vests on its own clock. 15% of every payment goes to the fee wallet and 85% to the treasury.',
  'docs.stakeH': 'Staking',
  'docs.stakeP': 'Six plans, each compounding every 12 hours: no lock (withdraw any time; this is the SYN ↔ sSYN conversion), 30, 90, 180 and 365-day locks (when a lock ends the stake can be withdrawn and keeps compounding at the no-lock rate), and permanent (the deposit never leaves; the rewards can be withdrawn at any time). Rewards are newly minted, within a hard per-epoch cap.',
  'docs.refH': 'Referral',
  'docs.refP': 'You earn {direct} of the staking rewards of everyone you invite, plus your rank’s rate on the staking rewards of your weaker leg. Referral rewards and principal you withdraw count toward a cap of {cap} of your peak active stake. You must be staking to earn and to claim.',
  'docs.treasuryH': 'Treasury and buyback',
  'docs.treasuryP': 'Bond payments and fees build a treasury controlled by the project’s multisig. When the 30-minute price falls well below its 7-day high, the treasury buys SYN back on PancakeSwap in bounded amounts and burns it.',
  'docs.feesH': 'Fees',
  'docs.action': 'Action',
  'docs.feeCol': 'Fee',
  'docs.feeBond': 'Bond',
  'docs.feeStake': 'Stake deposit',
  'docs.feeUnstake': 'Unstake, withdraw or claim from staking',
  'docs.feeSwap': 'Swap or transfer SYN',
  'docs.feeSwapV': '0% tax (pool fee only)',
  'docs.ranksH': 'Ranks',
  'docs.rankCol': 'Rank',
  'docs.threshold': 'Team volume',
  'docs.perSide': 'Each side',
  'docs.rateCol': 'Binary rate',
  'docs.risksH': 'Risks',
  'docs.risk1': 'SYN’s price can fall. Rewards are paid in SYN, so their value moves with it.',
  'docs.risk2': 'Minting new tokens for rewards increases supply; rates are adjustable and not guaranteed.',
  'docs.risk3': 'Smart contracts can contain bugs. Use only what you can afford to lose.',
  'docs.risk4': 'Check every transaction in your wallet: network, token, spender, amount. Never share your seed phrase.',
  'docs.risk5': 'Nothing on this site is financial advice. Local rules on crypto-assets and referral programs may apply to you.',
  'docs.contractsH': 'Contracts',
  'docs.contract': 'Contract',
  'docs.address': 'Address',
  'admin.eyebrow': 'Governance',
  'admin.title': 'Protocol administration',
  'admin.roleNote':
    'Changes go through the {delay} timelock: an admin wallet schedules them, then executes them once the delay has passed. Pausing is instant.',
  'admin.youProposer': 'This wallet is an admin: it can schedule and execute changes and pause the contracts.',
  'admin.notProposer': 'This wallet is not an admin. Connect an admin wallet in MetaMask (or any other wallet) to schedule and execute changes here.',
  'admin.staking': 'Staking',
  'admin.bonds': 'Bonds',
  'admin.referral': 'Referral',
  'admin.mint': 'Mint budgets (per 12 h epoch)',
  'admin.buyback': 'Buyback',
  'admin.oracle': 'Oracle',
  'admin.paused': 'Paused',
  'admin.active': 'Active',
  'admin.available': 'available now',
  'admin.propose': 'Prepare a change',
  'admin.action': 'Change',
  'admin.actRates': 'Staking rates',
  'admin.actMarket': 'Bond market',
  'admin.actBuyback': 'Buyback settings',
  'admin.actUnpause': 'Unpause a module',
  'admin.market': 'Market',
  'admin.enabled': 'Enabled',
  'admin.roiMin': 'ROI min (%)',
  'admin.roiMax': 'ROI max (%)',
  'admin.capacity': 'Capacity per period (SYN)',
  'admin.trigger': 'Trigger below 7-day high (%)',
  'admin.maxTrade': 'Max per trade (USDT)',
  'admin.maxDay': 'Max per day (USDT)',
  'admin.slip': 'Slippage (%)',
  'admin.cooldownH': 'Cooldown (hours)',
  'admin.burn': 'Burn bought SYN',
  'admin.module': 'Module',
  'admin.target': 'Target',
  'admin.calldata': 'Call data',
  'admin.schedule': 'Schedule via timelock',
  'admin.copyJson': 'Copy Safe Transaction Builder JSON',
  'admin.copied': 'Copied',
  'admin.queue': 'Timelock queue',
  'admin.noQueue': 'No scheduled operations.',
  'admin.op': 'Operation',
  'admin.eta': 'Executable',
  'admin.state': 'State',
  'admin.waiting': 'Waiting',
  'admin.ready': 'Ready',
  'admin.done': 'Done',
  'admin.cancelled': 'Cancelled',
  'admin.execute': 'Execute',
  'admin.emergency': 'Emergency pause',
  'admin.emergencyNote': 'Pausing stops new deposits, bonds, bindings and referral claims. Withdrawals and bond claims always stay open. Unpausing goes through the timelock.',
  'admin.pause': 'Pause {module}',
  'admin.pauseSafeOnly': 'Only an admin wallet can pause these contracts. This wallet can see their status here.',
  'admin.wallets': 'Admin wallets:',
  'admin.actAddAdmin': 'Add an admin wallet',
  'admin.actRemoveAdmin': 'Remove an admin wallet',
  'admin.wallet': 'Wallet address',
  'admin.walletInvalid': 'Enter a wallet address (0x followed by 40 characters).',
  'admin.walletAlready': 'This wallet is already an admin.',
  'admin.walletNotAdmin': 'This wallet is not an admin.',
  'admin.walletLast': 'This is the only admin wallet. Add another admin first, or no one could make changes any more.',
  'admin.addAdminNote': 'Once executed, this wallet can schedule and execute changes and pause the contracts, from MetaMask or any other wallet.',
  'admin.removeAdminNote': 'Once executed, this wallet can no longer schedule, execute or pause.',
  'admin.moreCalls': '{n} more',
  'admin.needAdmin': 'Admin wallet required',
  'dash.activity': 'Your recent activity',
  'dash.noActivity': 'No activity yet.',
  'dash.activityNeedsIndexer': 'Activity history needs the indexer (set VITE_INDEXER_URL).',
  'act.stake': 'Staked',
  'act.bind': 'Joined under a referrer',
  'act.bond': 'Bought a bond',
  'act.bond_claim': 'Claimed a bond',
  'act.referral_claim': 'Claimed referral rewards',
  'page.dashboard.sub': 'Stake. Rebase. Grow.',
  'page.stake.sub': 'Six plans, all compounding every 12 hours.',
  'page.bond.sub': 'Buy SYN below market, unlocked in 7 days.',
  'page.swap.sub': 'Trade SYN, USDT and BNB on PancakeSwap.',
  'page.liquidity.sub': 'Pair SYN with USDT and bond the LP.',
  'page.referral.sub': 'Grow both legs of your binary team.',
  'page.docs.sub': 'How Syntra works, in plain words.',
  'page.admin.sub': 'Parameters, timelock and emergency controls.',
  'side.active': 'Active',
  'side.epoch': 'Epoch',
  'side.endsIn': 'Ends in',
  'social.soon': 'Link coming soon',
  'wallet.connected': 'Connected',
  'price.label': 'SYN Price',
  'price.twap': '30-min avg',
  'notes.title': 'Notifications',
  'notes.nextRebase': 'Epoch {n} rebases in',
  'notes.rate': 'Rates per epoch (no lock – permanent)',
  'notes.empty': 'No wallet activity yet.',
  'dash2.balance': 'sSYN Balance',
  'dash2.staked': 'Staked balance',
  'dash2.allStaked': 'Staked by all holders',
  'dash2.growth': 'Rebase growth',
  'dash2.thisEpoch': '+{pct} last epoch',
  'dash2.nextEpoch': '+{pct} next rebase',
  'dash2.apy': 'APY',
  'dash2.apyInfo': 'The permanent plan, compounding every 12 hours at what it pays today: its rate, or less once the reward budget binds. Not a promise of returns.',
  'dash2.currentApy': 'Permanent APY',
  'dash2.rateOfMax': '{rate} of the {max} maximum per epoch',
  'dash2.binaryRate': '{rate} binary',
  'dash2.needTotal': '{amount} more team volume',
  'dash2.needWeaker': '{amount} more on your weaker leg',
  'dash2.stillNeeded': 'Still needed: {needs}.',
  'dash2.reqMet': 'Both requirements met: the new rank applies with your team’s next activity.',
  'dash2.topRank': '{rank} reached · {rate} binary',
  'dash2.rankConnect': 'Connect a wallet to see your progress to the next referral rank.',
  'dash2.overview': 'Rebase Overview',
  'dash2.overviewInfo': 'Growth of 1 sSYN from rebases over the period.',
  'dash2.projectedNote': 'Projected at today\'s rate: no rebase history yet.',
  'dash2.epochN': 'Epoch +{n}',
  'dash2.rebases': 'Rebases',
  'dash2.inPeriod': 'in this period',
  'dash2.avgRebase': 'Avg. rebase',
  'dash2.perEpoch': 'per epoch',
  'dash2.projection': 'Rewards Projection',
  'dash2.projectionInfo': 'What your stake earns from rebases at today\'s rates. Rates can change; this is not a promise.',
  'dash2.days': '{n} days',
  'dash2.day': 'Day {n}',
  'dash2.example': 'for 1,000 SYN with no lock',
  'dash2.allocation': 'Staking Allocation',
  'dash2.allocationInfo': 'Your SYN: staked, in your wallet, and the rewards compounded above your deposits.',
  'dash2.allocationAllInfo': 'All SYN: in locked plans, with no lock, and not staked.',
  'dash2.stakedShort': 'Staked',
  'dash2.available': 'Available',
  'dash2.rewards': 'Rewards',
  'dash2.locked': 'Locked',
  'dash2.unstaked': 'Not staked',
  'dash2.ofSupply': 'of supply staked',
  'dash2.stakeMore': 'Stake more SYN',
  'dash2.period': 'Projection period',
  'dash2.orbLabel': '{staked} sSYN staked · {pct} of the way to the next rebase · {share} of supply staked · {rate} reward per epoch',
  'dash2.rebasing': 'Rebasing every 12 h',
  'dash2.nextRebase': 'Next rebase',
  'dash2.index': 'sSYN index',
  'dash2.nextUnlock': 'Next unlock',
  'dash2.allUnlocked': 'Unlocked',
  'dash2.noLocks': 'No locked deposits',
  'dash2.stakedSupply': 'Staked of supply',
  'dash2.perDay': 'Per day',
  'dash2.atRate': 'at today\'s rate',
  'dash2.periodYield': 'Period yield',
  'dash2.onStake': 'on the staked amount',
  'dash2.totalStaked': 'Total staked',
  'dash2.lockedPlusFlex': 'sSYN across every plan',
  'dash2.stakedValue': 'Staked value',
  'dash2.atTwap': 'at the 30-min average',
  'dash2.mintedLastN': 'SYN to all stakers · last {n} epochs',
  'dash2.mintedNextN': 'SYN to all stakers · next {n} epochs at today\'s rate',
  'stake.compounding': 'compounding every epoch',
  'bond.insight': '{asset} market',
  'bond.openNow': 'Open',
  'bond.marketPrice': 'Market price',
  'bond.capLeft': 'Capacity left this period',
  'bond.roiBand': 'The ring fills toward this market\'s {max} ROI ceiling. ROI moves between {min} and {max} as bonds sell and debt decays.',
  'swap.priceChart': 'SYN price',
  'swap.priceRange': 'Price range',
  'swap.noHistory': 'Price history builds up hour by hour as the pool trades.',
  'swap.noIndexer': 'Connect an indexer to see price history.',
  'swap.priceNote': 'Closes from the SYN-USDT pool; an hour without trades keeps the last price.',
  'liq.ownership': 'Pool ownership',
  'liq.treasury': 'Treasury (protocol-owned)',
  'liq.you': 'You',
  'liq.others': 'Other holders',
  'liq.yourShare': 'your share',
  'liq.polShort': 'protocol-owned',
  'liq.tvlSub': 'both sides at the pool price',
  'liq.locked': 'Locked (initial liquidity)',
  'liq.lockedShort': 'locked',
  'liq.lockedUntil': '{pct} of the pool is the initial liquidity, locked until {date}; it can then go only to the management wallet.',
  'liq.lockContract': 'Lock contract',
  'ref.yourRank': 'Your rank',
  'ref.nextRate': 'Next: {rank} · {rate}',
  'ref.toNext': 'to next rank',
  'ref.topRankShort': 'Top rank',
  'ref.legs': 'Active volume by leg',
  'ref.weakerShare': 'The weaker leg holds {pct} of your volume.',
  'ref.rankConnect': 'Connect a wallet to see your rank and both legs of your tree.',
  'ref.earnTitle': 'How you earn',
  'ref.earnDirect': 'Direct bonus',
  'ref.earnDirectP': '{pct} of the staking rewards of everyone you invite.',
  'ref.earnBinary': 'Binary reward',
  'ref.earnBinaryP': 'Your rank\'s rate, {min} to {max}, on the yield of your weaker leg.',
  'ref.earnCap': 'Earning cap',
  'ref.earnCapP': 'Rewards plus withdrawn principal stop at {pct} of your peak active stake.',
  'testnet.pill': 'BSC testnet',
  'testnet.text': 'Test money only: nothing here has real value. One press sends you test BNB for network fees and 1,000 test USDT. More test BNB:',
  'testnet.faucet': 'BNB Chain faucet',
  'testnet.mint': 'Get test BNB + 1,000 USDT',
  'testnet.mintOnchain': 'Get 1,000 test USDT',
  'testnet.sending': 'Sending…',
  'testnet.sent': 'Sent: test BNB for fees and 1,000 test USDT.',
  'testnet.sentUsdt': 'Sent 1,000 test USDT (you already have BNB for fees).',
  'testnet.sentNoBnb': 'Sent 1,000 test USDT. The faucet is out of test BNB right now; get some from the BNB Chain faucet.',
  'testnet.cooldown': 'This wallet already received test funds. Try again in {time}.',
  'testnet.limit': 'The faucet reached its limit for now. Try again in {time}.',
  'testnet.failed': 'The faucet could not send right now. Try again in a minute.',
  'plan.0': 'No lock',
  'plan.1': '30-day lock',
  'plan.2': '90-day lock',
  'plan.3': '180-day lock',
  'plan.4': '365-day lock',
  'plan.5': 'Permanent',
  'plan.apy': 'APY {pct}',
  'plan.lockNone': 'Withdraw any time',
  'plan.lockDays': 'Locked {days} days',
  'plan.featured': 'Best rate',
  'plan.featuredNoFees': 'Best rate · Zero fees',
  'plan.lockForever': 'Deposit locked forever',
  'plan.fees': 'Fee {in} in · {out} out',
  'plan.noFees': 'No fees in or out',
  'stake.feeNone': 'Stake fee',
  'stake.noFee': 'None',
  'stake.exitFeePermanentFree': 'The deposit never leaves; rewards withdraw with no fee',
  'stake.youReceiveNoFee': 'You receive {amount} SYN, no fee',
  'plan.anytime': 'Any time',
  'plan.never': 'Never (rewards any time)',
  'plan.aboutLocked': 'Locked for {days} days at a higher rate, compounding every 12 hours. When the lock ends it can be withdrawn and keeps compounding at the no-lock rate.',
  'plan.aboutPermanent': 'The highest rate. The deposit stays locked forever; the rewards above it compound every 12 hours and can be withdrawn any time.',
  'plan.about0': 'sSYN with no lock: it compounds every 12 hours and can be withdrawn any time. This is the SYN ↔ sSYN conversion on the Swap page.',
  'stake.choose': 'Choose a plan',
  'stake.form': 'Stake · {plan}',
  'stake.claimRewards': 'Claim rewards',
  'stake.noRewardsYet': 'No rewards yet',
  'stake.lockEnded': 'Lock ended',
  'stake.endedRate': 'Now compounding at the no-lock rate',
  'stake.projectionSwitch': 'After the {days}-day lock the projection continues at the no-lock rate. At today’s rates; not a promise of returns.',
  'stake.exitFeePermanent': 'The deposit never leaves; rewards pay {pct} when withdrawn',
  'convert.flip': 'Turn around: {to} → {from}',
  'convert.title': 'Convert SYN ↔ sSYN',
  'convert.from': 'You convert ({token})',
  'convert.to': 'You receive ({token})',
  'convert.rate': 'Rate',
  'convert.rateValue': '1 : 1, less the {pct} tax',
  'convert.tax': 'Conversion tax ({pct})',
  'convert.earns': 'sSYN earns',
  'convert.earnsValue': '{apr} APR · {apy} APY, compounding every 12 hours',
  'convert.about': 'sSYN is SYN staked with no lock: it grows every 12 hours and converts back at any time. The tax goes to the treasury; nothing passes through the pool.',
  'convert.ctaIn': 'Convert to sSYN',
  'convert.ctaOut': 'Convert to SYN',
  'swap.mode': 'Mode',
  'swap.nativeCoin': 'Native coin',
  'swap.modeSwap': 'PancakeSwap',
  'dash.apyPermanent': 'APY · Permanent',
  'dash.apyNoLock': 'APY · No lock',
  'dash.stakedAll': 'Staked (sSYN, all plans)',
  'dash2.noLockApy': 'No lock {apy}',
  'dash2.noLock': 'No lock',
  'dash2.lockedPlans': 'sSYN in the 30/90/180/365-day and permanent plans',
  'dash2.anytime': 'sSYN, withdraw any time',
  'docs.feePlans': 'No lock {noLock} · 30/90/180/365-day locks {locked} · permanent {perm}',
  'admin.actFees': 'Staking fees',
  'admin.planApr': '{plan}: APR (%)',
  'admin.feeNoLockIn': 'No lock: fee in (%)',
  'admin.feeNoLockOut': 'No lock: fee out (%)',
  'admin.feeLockedIn': 'Locked plans: fee in (%)',
  'admin.feeLockedOut': 'Locked plans: fee out (%)',
  'admin.feePermanentIn': 'Permanent plan: fee in (%)',
  'admin.feePermanentOut': 'Permanent plan: fee out on rewards (%)',
  'act.withdraw': 'Withdrew',
  'act.claim_rewards': 'Claimed rewards',
  'stake.unlocksIn': 'Unlocks in',
  'stake.permanentNote': 'Deposit locked forever · rewards any time',
  'stake.endedOn': 'Lock ended {date}',
  'err.ZeroAmount': 'Enter an amount greater than zero.',
  'err.RebaseBacklog': 'Unpaid reward epochs: {n}. New stakes wait until they are paid. Press Catch up below, or wait for the keeper, then try again.',
  'err.LotLocked': 'This position is locked until {date}. You can withdraw it from then on.',
  'err.LotEmpty': 'This position was already withdrawn in full.',
  'err.InsufficientStake': 'That is more than this position holds: {available} SYN can be withdrawn. Enter a smaller amount or press Max.',
  'err.PermanentPrincipal': 'A permanent stake never leaves; only its rewards can be taken, {available} SYN right now. Enter at most that.',
  'err.UnknownPlan': 'That plan does not exist. Reload the page and choose a plan again.',
  'err.NothingToClaim': 'Nothing to claim yet. Referral rewards accrue every 12 hours while your team stakes.',
  'err.NotEligible': 'Stake SYN first: referral rewards are only paid while you have an active stake.',
  'err.AlreadyBound': 'This wallet already belongs to a team; a referrer cannot be changed.',
  'err.SponsorNotBound': 'That referrer has not joined yet, so nobody can join under them. Ask them to join first.',
  'err.SelfReferral': 'You cannot be your own referrer.',
  'err.PlacementTooDeep': 'That side of the team is too long to place you right now. Join through the other side, or ask the referrer to repair the line.',
  'err.MarketClosed': 'This bond market is closed for now. Choose another market or come back later.',
  'err.UnknownMarket': 'That bond market does not exist. Reload the page.',
  'err.CapacityExceeded': 'This market has only {left} SYN left this period; this bond would be {payout} SYN. Enter a smaller amount or wait for the next period.',
  'err.MaxPayoutExceeded': 'Each bond can buy at most {max} SYN; this one would be {payout} SYN. Enter a smaller amount or buy in parts.',
  'err.SlippageExceeded': 'The price moved while you confirmed: this bond would pay {payout} SYN, under the {min} SYN you accepted. Refresh the quote and try again.',
  'err.ValueMismatch': 'The BNB sent does not match the amount entered. Reload the page and try again.',
  'err.NotOwner': 'This bond belongs to another wallet.',
  'err.AlreadyClaimed': 'This bond was already claimed.',
  'err.StillVesting': 'This bond unlocks on {date}, 7 days after purchase. Come back then.',
  'err.PriceDeviation': 'Bonds are paused for now: the pool price (${spot}) is {dev}% away from its 30-minute average (${twap}). To protect against price manipulation, bonds only open while the two are within {max}%. They reopen by themselves as the average catches up, usually within 30 minutes.',
  'err.OracleNotReady': 'The price oracle is still gathering its first 30 minutes of history. Try again shortly.',
  'err.StalePrice': 'A price feed has not updated for {age}, so this asset cannot be priced safely right now. It reopens as soon as the feed updates; other assets are unaffected.',
  'err.InvalidPrice': 'A price feed returned an invalid value. Try again shortly, or use another asset.',
  'err.StablecoinDepeg': 'USDT is trading at ${price}, outside the safe band, so pricing is paused until it returns. Nothing is lost; try again later.',
  'err.UnsupportedAsset': 'That asset cannot be priced here.',
  'err.MinterBudgetExceeded': 'This epoch\'s reward budget is used up ({available} SYN left). It refills every 12 hours; try again next epoch.',
  'err.GlobalBudgetExceeded': 'The protocol\'s reward budget for this epoch is used up ({available} SYN left). It refills every 12 hours; try again next epoch.',
  'err.MinterDisabled': 'Minting is switched off for this contract for now. Nothing is lost; try again later.',
  'err.EnforcedPause': 'This action is paused by the protocol\'s admin. Withdrawals and claims stay open; new deposits resume once it is unpaused.',
  'err.AccessControlUnauthorizedAccount': 'This wallet does not hold the role needed for that action.',
  'err.TimelockUnexpectedOperationState': 'The timelock refused this: the change is not ready yet, was already executed, or was cancelled. Check the queue.',
  'err.TimelockUnauthorizedCaller': 'Only an admin wallet can schedule or execute changes.',
  'err.ERC20InsufficientBalance': 'Not enough tokens: {needed} needed, {have} in your wallet.',
  'err.ERC20InsufficientAllowance': 'The contract is not approved for this amount yet. Approve it first, then try again.',
  'err.NonTransferable': 'sSYN cannot be transferred: it is your staking balance. Withdraw from the Stake page instead.',
  'err.StillLocked': 'The initial liquidity is locked until {date}.',
  'err.CooldownActive': 'The buyback is cooling down until {date}.',
  'err.group.setting': 'The contract refused that setting ({name}). Check the values and try again.',
  'err.group.timelock': 'The timelock refused this ({name}). Check the queue and the delay, then try again.',
  'err.group.token': 'A token transfer failed ({name}). Check the amount and your balance, then try again.',
  'err.group.internal': 'The contract refused the call ({name}). Reload the page and try again; if it keeps happening, tell the team.',
  'err.group.lock': 'The liquidity lock refused this ({name}). Only the management wallet can change it, and only to a later date.',
  'err.group.buyback': 'The buyback refused this ({name}): it only runs within its trigger, cooldown and daily limits.',
  'err.group.upgrade': 'The upgrade was refused ({name}). Check the implementation address and that it is a UUPS contract.',
  'err.group.signature': 'The signature was refused ({name}). Sign again from the wallet that owns the tokens.',
  'err.unknown': 'The contract refused the request ({name}). Reload the page and try again.',
  'err.noGas': 'Not enough BNB in your wallet to pay the network fee. Add a little BNB and try again.',
  'err.walletGeneric': 'Your wallet could not complete the request. Unlock it and try again.',
  'err.wallet.4001': 'You rejected the request in your wallet.',
  'err.wallet.4100': 'Your wallet has not authorised this site yet. Unlock it and try again.',
  'err.wallet.4200': 'Your wallet does not support this request.',
  'err.wallet.4900': 'Your wallet is disconnected from the network. Check it and try again.',
  'err.wallet.4901': 'Your wallet is not connected to this network.',
  'err.wallet.4902': 'Add BNB Smart Chain to your wallet, then try again.',
  'err.wallet.-32002': 'Your wallet already has a request waiting. Open the wallet and approve or close it first.',
  'err.wallet.-32603': 'Your wallet reported an internal error. Unlock it, reload the page and try again.',
  'epoch.behindTitle': 'Rewards for the last {n} epochs are waiting to be paid.',
  'epoch.behindBody': 'Staking and SYN → sSYN conversions resume once they are processed. Anyone can do it; it costs only the network fee.',
  'epoch.catchUp': 'Catch up',
  'epoch.progress': '{done} of {total} epochs processed…',
  'epoch.caughtUp': 'All epochs are paid. You can stake again.',
  'common.fee': '≈ {amount} BNB network fee',
  'docs.refCode': 'Your invite code is 8 characters derived from your wallet address. Should two wallets ever share a code, the one that joined first keeps it; the other invites by wallet address.',
  'news.title': 'What’s new',
  'news.fee': 'The network fee of every action is shown under its button before you confirm, and this panel lists what changed.',
  'news.catchUp': 'When reward epochs are waiting, a bar on every page offers Catch up, and every error now says what happened and what to do next.',
  'news.ranksLock': 'Ranks count the two legs that are staking at the same time, and a lock contract holds the project’s SYN-USDT liquidity for 12 months.',
  'news.joinFirst': 'Invited wallets are asked to join their inviter’s team before their first stake; flags in the language menu, community links, and an Admin page that works with any admin wallet.',
  'news.emblems': 'Rank emblems and the next rank step on the dashboard, token menus and a flip button on Swap, and 3D network, tree and staking views.',
  'news.plans': 'Six staking plans: no lock, 30, 90, 180 and 365-day locks, and permanent with no fees; invite links carry an 8-character code.',
  'news.staking': 'SYN and sSYN, compounding plans with the SYN ↔ sSYN conversion, a one-press faucet, and every contract’s source verified on BscScan.',
  'news.live': 'Live on BSC testnet with the Syntra brand, in English, Japanese and Korean.',
  'plan.upTo': 'up to',
  'plan.paying': 'paying {pct} now (reward budget)',
  'dash2.budget': 'Reward budget',
  'dash2.budgetUsed': '{used} of {cap} SYN per epoch used',
  'dash2.budgetCapped': 'The budget is short: every plan pays {pct} of its rate this epoch.',
  'dash2.rateNote': 'At today’s rate; the reward budget can lower it.',
  'docs.budgetP': 'Each plan’s APR is a maximum. Rewards come from a budget of {cap} SYN per epoch; when the plans together would need more, every plan pays the same share of its rate, so the paid rate falls as the pool grows. Today the plans need {wanted} SYN per epoch.',
  'err.FeeBelowRate': 'Refused: on a plan you can withdraw from, the entry plus exit fee must cover one epoch’s rate (plan {plan}: {fee} of fees against {rate} per epoch).',
  'news.rates': 'Plan rates read “up to”: when the reward budget is short, the cards say what they pay now, and the dashboard shows the budget meter.',
  'bond.reopensIn': 'Reopens in about {time}, when the average next moves; sooner if the price comes back.',
  'price.moving': 'Price moving: the pool is {dev} from its average.',
  'price.movingRules': 'Nothing pauses here: a stake is booked at the lower of the two prices and a referral claim paid at the higher. Bonds wait until they agree.',
  'news.price': 'Staking and referral claims never pause for a price swing: a stake is booked at the lower of average and spot, a claim paid at the higher. The bond banner says when bonds reopen, and a “price moving” chip appears on Stake and Referral.',
  'gov.c.staking': 'Staking',
  'gov.c.bonds': 'Bonds',
  'gov.c.referral': 'Referral',
  'gov.c.buyback': 'Buyback',
  'gov.c.registry': 'Mint registry',
  'gov.c.timelock': 'Timelock',
  'gov.c.treasury': 'Treasury',
  'gov.c.oracle': 'Price oracle',
  'gov.c.lpLock': 'Liquidity lock',
  'gov.c.unknown': 'a contract',
  'gov.r.proposer': 'admin (proposer)',
  'gov.r.executor': 'admin (executor)',
  'gov.r.canceller': 'veto (canceller)',
  'gov.r.pauser': 'pauser',
  'gov.r.admin': 'owner',
  'gov.r.treasurer': 'treasurer',
  'gov.r.keeper': 'keeper',
  'gov.r.staking': 'staking',
  'gov.r.stakeFor': 'stake-for',
  'gov.r.other': 'unknown',
  'gov.rates': 'Staking rates change to {aprs} APR (no lock · 30 · 90 · 180 · 365 days · permanent).',
  'gov.fees': 'Staking fees change: in {ins}, out {outs}; fee wallet {recipient}.',
  'gov.maxRate': 'The maximum staking rate changes to {pct} per epoch.',
  'gov.referralWiring': 'Staking is wired to the referral contract {address}.',
  'gov.market': 'Bond market {id}: {state}, ROI {min}–{max}, capacity {cap} SYN per period.',
  'gov.marketNew': 'A new bond market: {state}, ROI {min}–{max}, capacity {cap} SYN per period.',
  'gov.open': 'open',
  'gov.closed': 'closed',
  'gov.buyback': 'Buyback settings: trigger {trigger} below the 7-day high, up to {perTrade} USDT per trade and {perDay} per day, slippage {slip}, cooldown {cooldown}, bought SYN {bought}.',
  'gov.burned': 'burned',
  'gov.kept': 'kept in the treasury',
  'gov.minter': 'Mint budget of {contract}: {cap} SYN per epoch, burst {n} epochs, {state}.',
  'gov.enabled': 'enabled',
  'gov.disabled': 'disabled',
  'gov.globalCap': 'Global mint budget: {cap} SYN per epoch, burst {n} epochs.',
  'gov.referralRates': 'Referral rates: direct {direct}; ranks {ranks}; at least {minSide} per side.',
  'gov.maxDepth': 'Referral volume climbs {n} levels.',
  'gov.capMultiplier': 'Referral cap: {pct} of the peak active stake.',
  'gov.pause': '{contract} is paused.',
  'gov.unpause': '{contract} is unpaused.',
  'gov.upgrade': 'The {contract} contract is upgraded to the implementation {impl}.',
  'gov.roleGrant': '{account} gets the {role} role on {contract}.',
  'gov.roleRevoke': '{account} loses the {role} role on {contract}.',
  'gov.delay': 'The timelock delay changes to {time}.',
  'gov.treasury': 'Treasury {fn}: {args}.',
  'gov.unknown': 'Call {selector} on {contract}.',
  'docs.upcomingH': 'Upcoming changes',
  'docs.upcomingNote': 'Every change to the protocol goes through the 48-hour timelock: an admin wallet schedules it, it is listed here for the whole delay, and a veto wallet can cancel it until it runs.',
  'docs.upcomingNone': 'No changes are scheduled.',
  'docs.upcomingAt': 'executable on {date}',
  'docs.upcomingReady': 'can be executed now',
  'docs.upcomingAfter': 'after operation {id}',
  'notes.change': 'Scheduled change',
  'notes.changeDone': 'Change executed',
  'admin.actAddVeto': 'Add a veto wallet',
  'admin.actRemoveVeto': 'Remove a veto wallet',
  'admin.vetoNote': 'A veto wallet can only cancel scheduled changes. Keep it in a hardware wallet that never operates the protocol: it is the one key that can stop a hostile change during the 48 hours.',
  'admin.removeVetoNote': 'Once executed, this wallet can no longer cancel scheduled changes.',
  'admin.vetoAlready': 'This wallet already holds the veto right.',
  'admin.vetoNotVeto': 'This wallet holds no veto right.',
  'admin.vetoWallets': 'Veto wallets:',
  'admin.noVeto': 'No veto wallet yet. Only the admin wallets could cancel a hostile change scheduled with a stolen key. Add a cold wallet that holds only the cancel right.',
  'admin.youCanceller': 'This wallet holds the veto right: it can cancel scheduled changes in the queue below.',
  'admin.actUpgrade': 'Upgrade a contract',
  'admin.proxy': 'Contract',
  'admin.implementation': 'New implementation address',
  'admin.implInvalid': 'Enter the implementation address (0x followed by 40 characters).',
  'admin.implChecking': 'Checking the implementation…',
  'admin.implNotUups': 'This address is not a UUPS implementation: its proxiableUUID check failed.',
  'admin.implOk': 'A UUPS implementation. Review its verified source before scheduling.',
  'admin.implSource': 'Source on BscScan',
  'admin.upgradeNote': 'Once executed, the proxy runs the new implementation with its storage untouched. Rehearse on a fork first (npm run contracts:rehearsal).',
  'admin.cancel': 'Cancel',
  'admin.cancelNote': 'Cancelling removes the operation for good; it can be scheduled again later.',
  'news.rates2': 'New staking rates: the 365-day lock pays 250% APR and the permanent plan 365% APR. The change goes through the 48-hour timelock and is listed under “Upcoming changes” until it applies.',
  'news.gov': 'Every scheduled change is listed under “Upcoming changes” on this page and in the bell, in plain words and with its time; admins can add a veto wallet that can only cancel, and schedule contract upgrades from the Admin page.',
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Partial<Record<MessageKey, string>>;
